<app-consumption-device-steps *ngIf="!isDetailsView" [currentStep]="ApplicationStepType.TechnicalData"></app-consumption-device-steps>

<div class="page-padding" *ngIf="!isDetailsView">
  <app-application-header
    [title]="'installation-data.ccd-drr' | translate"
    [applicationExternalId]="applictionData?.application_ext_id"></app-application-header>
</div>

<div class="page-padding page-title">
  <app-page-header [title]="'technician-data.technical-data-title' | translate"></app-page-header>
</div>

<app-drr-ccd-data-context>
  <div class="page-padding" [formGroup]="form">
    <div *ngFor="let device of devices; index as i" [@addRemoveAnimation]>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 pdf-page-section">
        <app-drr-ccd-device
          (formInited)="initCcdDrrDeviceForm($event, device)"
          (remove)="removeDevice(i)"
          [canBeDeleted]="devices?.length > 1 && !isDetailsView"
          [data]="device.get('rawValue')?.value"
          [isDetailsView]="isDetailsView"
          [applicationId]="applicationId"
          [index]="i"></app-drr-ccd-device>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 pb-1">
      <app-plus-button
        *ngIf="!isDetailsView"
        [label]="drrCcdDeviceLabelKey | translate"
        (onClick)="addControllableConsumptionDevice(null)"></app-plus-button>
    </div>

    <app-review-section
      *ngIf="form.value?.devices[0]?.device?.ccdType"
      #summarySection
      [title]="'drr-ccd-devices.summary-on-ccd-header' | translate"
      class="page-padding"
      [sectionId]="SectionIdentifier.DrrCcd_TechnicalData_Summary"
      [applicationId]="applicationId"
      [isDetailsView]="isDetailsView">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-container">
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
          <app-input-number
            [label]="'drr-ccd-devices.heat-pump-total-power-lbl' | translate"
            [formControl]="form.controls.totalHeatPumpPower"></app-input-number>
        </div>
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
          <app-input-number
            [label]="'drr-ccd-devices.air-conditioner-total-power-lbl' | translate"
            [formControl]="form.controls.totalAirConditionerPower"></app-input-number>
        </div>
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
          <app-input-number
            [label]="'drr-ccd-devices.wallbox-total-power-lbl' | translate"
            [formControl]="form.controls.totalWallboxPower"></app-input-number>
        </div>
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
          <app-input-number
            [label]="'drr-ccd-devices.storage-total-power-lbl' | translate"
            [formControl]="form.controls.totalStoragePower"></app-input-number>
        </div>
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 required-power-border">
          <app-input-number
            [label]="'drr-ccd-devices.simultaneously-required-power-lbl' | translate"
            [formControl]="form.controls.simultaneouslyRequiredPower"
            [forceDisable]="!summarySection.isDataEditable">
            <app-suffix>
              <span class="unit-margin">{{ 'drr-ccd-devices.power-units' | translate }}</span>
              <app-tooltip [text]="'drr-ccd-devices.simultaneously-required-power-inf' | translate"></app-tooltip>
            </app-suffix>
          </app-input-number>
        </div>
      </div>
    </app-review-section>

    <app-drr-ccd-commissioning-data
      *ngIf="drrCcdCommissioningData"
      [data]="drrCcdCommissioningData"
      [isDetailsView]="isDetailsView"
      [applicationId]="applicationId"
      (initForm)="initCommissioningDataForm($event)"></app-drr-ccd-commissioning-data>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-container btn-bottom" *ngIf="!isDetailsView">
      <button
        type="button"
        (click)="save()"
        [label]="'proceed' | translate"
        pButton
        [disabled]="!(form?.valid && commissioningDataForm?.valid)"></button>
    </div>
  </div>
</app-drr-ccd-data-context>

<app-loader *ngIf="loading"></app-loader>
